import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/lib/api/orpc';

/** Login method policy（SSO ログイン強制）のクエリ／ミューテーション。 */

const loginMethodPolicy = orpc.loginMethodPolicy;
const LOCAL_ERROR_META = {
  disableGlobalErrorHandling: true
} as const;
export const loginMethodPoliciesQueryOptions = () => ({
  ...loginMethodPolicy.getOrgPolicies.queryOptions({
    input: {}
  }),
  meta: LOCAL_ERROR_META
});
export const useLoginMethodPolicies = () => {
  return useQuery(loginMethodPoliciesQueryOptions());
};
export const useUpsertLoginMethodPolicy = () => {
  const queryClient = useQueryClient();
  return useMutation({
    ...loginMethodPolicy.upsertOrgPolicy.mutationOptions(),
    // ロックアウト防止ガードの 403 はカード内に BE メッセージを表示するため、
    // グローバルエラーダイアログは抑止する。
    meta: {
      disableGlobalErrorHandling: true
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: loginMethodPolicy.getOrgPolicies.key()
      });
    }
  });
};
export const useResetLoginMethodPolicy = () => {
  const queryClient = useQueryClient();
  return useMutation({
    ...loginMethodPolicy.deleteOrgPolicy.mutationOptions(),
    meta: {
      disableGlobalErrorHandling: true
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: loginMethodPolicy.getOrgPolicies.key()
      });
    }
  });
};